import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from './router'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    token: null,
    usuario: null,
	tokenChecked: false, // Nuevo estado para indicar si la comprobación del token se ha completado
  },
  mutations: {
    setToken(state,token){
		state.token=token
    },
    setUsuario (state,usuario){
		state.usuario=usuario
    },
	setTokenChecked(state, status) {
		state.tokenChecked = status;
	},
  },
  actions: {
    
    guardarToken({commit},token){
      //commit("setToken", token)
      commit("setUsuario", decode(token))
      localStorage.setItem("token", token)
    },
	autoLogin({ commit }) {
		return new Promise((resolve) => {
		  let token = localStorage.getItem('token');
		  if (token) {
			commit('setToken', token);
			commit('setUsuario', decode(token));
		  }
		  commit('setTokenChecked', true); // Indica que la comprobación del token ha finalizado
		  resolve();
		});
	  },
    salir({commit}){
      commit("setToken", null)
      commit("setUsuario", null)
      localStorage.removeItem("token")
      router.push({name: 'login'})
    }
  }
})
